var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentOnDutyFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 4c.233 0 .441.075.625.225a.88.88 0 01.325.575l.65 3.5c.034.233.03.445-.012.637a1.03 1.03 0 01-.288.513L6 11.9a16.61 16.61 0 002.625 3.375A18.295 18.295 0 0012.1 18l2.35-2.35a1.4 1.4 0 01.588-.338c.241-.075.479-.095.712-.062l3.45.7c.233.05.425.163.575.337.15.175.225.38.225.613v4.05c0 .3-.1.55-.3.75-.2.2-.45.3-.75.3-2.15 0-4.246-.48-6.287-1.439a19.043 19.043 0 01-5.425-3.8 19.042 19.042 0 01-3.8-5.424C2.48 9.296 2 7.2 2 5.05c0-.3.1-.55.3-.75.2-.2.45-.3.75-.3H7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 2a5 5 0 110 10 5 5 0 010-10zm-.5 5.207l2.146 2.147.707-.708L17.5 6.793V4.5h-1v2.707z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentOnDutyFill);
export default __webpack_public_path__ + "9d4ce7e3a7817c64e0c1f5e40c2f01f4.svg";
export { ForwardRef as ReactComponent };